module.exports = __webpack_public_path__ + "media/images/lb/568-0aef5e03c06559524298f8e87d6890c0.svg";